import { connect } from 'react-redux'
import Dashboard from 'modules/Dashboard/index'

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
